<template>
  <div class="flex flex-col sm:flex-row xl:flex-col my-3">
    <!--                 :class="[navItem.current ? 'text-gray-600' : 'text-gray-500 group-hover:text-secondary-400-c', 'flex-shrink-0 -ml-1 mr-2 h-4 w-4']"-->
    <button
      type="button"
      class="secondary-button uppercase inline-flex items-center justify-center px-4 py-1 shadow-sm text-sm font-medium rounded w-full focus:outline-none border-2 border-transparent focus:border-primary focus:ring-0"
      @click="$emit('click')"
    >
      <component :is="navItem.icon" class="flex-shrink-0 -ml-1 mr-2 h-4 w-4" aria-hidden="true"/>
      {{ navItem.name }}
    </button>
  </div>
</template>

<script>
export default {
  name: "ActionButtonNav",
  props: ["navItem"],
  emits: ['click']
}
</script>